import { RouterModule, Routes } from "@angular/router";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { AppComponent } from "./app.component";
import { SpellDashboardModule } from "../spell-dashboard/spell-dashboard.module";
import { SpellDashboardComponent } from "../spell-dashboard/containers/spell-dashboard/spell-dashboard.component";
import { Store } from "../store";
import { AuthModule } from "../auth/auth.module";

// Third-party modules
import { FirebaseAppConfig, AngularFireModule } from "angularfire2";
import { AngularFireAuthModule } from "angularfire2/auth";
import { AngularFireDatabaseModule } from "angularfire2/database";

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    SpellDashboardModule,
    AuthModule
  ],
  providers: [Store],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts